<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 9">
    <g>
      <g>
        <path
          d="M5.156 8.888V7.544h2.688v1.344zM.5.888h12v1.344H.5zm2 4.656V4.23h8v1.313z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FilterIcon',
}
</script>
